import { C } from './constants';

/**
 * Position badge — compact pill showing player position abbreviation.
 *
 * @param {string} pos - Position string (e.g., "PG", "Forward", "SF/PF")
 */
export const PosBadge = ({ pos }) => {
  const short = pos.length > 2 ? pos.substring(0, 2).toUpperCase() : pos.toUpperCase();
  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 36,
      height: 22,
      borderRadius: 6,
      background: C.goldDim,
      color: C.gold,
      fontSize: 10,
      fontWeight: 600,
      letterSpacing: 0.5,
    }}>
      {short}
    </span>
  );
};
